import { http } from '../core';
const apiFetchErrorRegions = async () => {
  const response = await http.get(
    process.env.VUE_APP_PUBLICPATH + 'mock/regions.json'
  );
  return response || null;
};

export { apiFetchErrorRegions };
